import { FEATURES } from '@constants/Text'

/**
 * Quem pode CURAR sugestões de IA no Consolidador.
 *
 * A regra vivia inline em cinco superfícies (selo da linha, legenda, aba, as duas views); no dia em
 * que a flag mudar, os cinco teriam que mudar juntos — e foi ter a mesma regra em dois lugares que
 * produziu o "selo conta 2 / painel abre 0" desta feature.
 *
 * O guard da ROTA não usa este helper: lá entra também `ASSET_LOCATION`, porque a aba é uma tela
 * do módulo de carteiras, e ele precisa continuar fail-closed por conta própria.
 */
export const podeCurarSugestoesIa = ({ user, access } = {}) => {
  const u = user || {}
  const a = access || {}
  if (u.IS_CLIENTE) return false
  return !!a[FEATURES.CONSOLIDADOR_SUGESTOES_IA]
}
